import { render, staticRenderFns } from "./SoftwareList.vue?vue&type=template&id=7f14012d"
import script from "./SoftwareList.vue?vue&type=script&lang=js"
export * from "./SoftwareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports